import * as React from 'react';

import t from './locales';
import { calculateItemPrice } from './helpers';
import { IOrderItem, IInsuranceOrderItem, ICurrency } from './types';

import InventoryListView from './InventoryListView';
import InventoryCartItemView from './InventoryCartItemView';
import Price from '../Shared/Price';

interface InventoryOrderItemListProps {
  items: Array<IOrderItem|IInsuranceOrderItem>;
  currentExchangeRate?: number;
  localCurrency?: ICurrency;
}

const InventoryOrderItemList: React.FC<InventoryOrderItemListProps> = (props) => {
  return (
    <React.Fragment>
      {props.items && props.items.map((item, index) => {
        const { price, people, resort } = item;
        const setProduct = item.type === 'Order' ? item.setProduct : undefined;
        const adultLabel = setProduct ? t.setProductNum() : t.adultNum();
        const itemPrice = calculateItemPrice(price, people);
        return (
          <InventoryCartItemView key={`inventory-order-item-${index}`}>
            <div>
              <p>{item.itemName}</p>
              <span className="mute">
                {resort && <span>{resort.resortName}</span>}
                {people.adultNum > 0 && <span>{adultLabel} {people.adultNum}</span>}
                {!setProduct && people.childNum > 0 && <span>{t.childNum()} {people.childNum}</span>}
                {!setProduct && people.studentNum > 0 && <span>{t.studentNum()} {people.studentNum}</span>}
                {!setProduct && people.seniorNum > 0 && <span>{t.seniorNum()} {people.seniorNum}</span>}
              </span>
            </div>
            <Price
              price={itemPrice.price}
              fullPrice={itemPrice.fullPrice}
              fontSize={12}
              localCurrency={props.localCurrency}/>
          </InventoryCartItemView>
        )
      })}
    </React.Fragment>
  );
}

export default InventoryOrderItemList;
